var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('ti-toast'),_c('default-bar'),_c('default-drawer'),_c('default-view'),_c('default-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }